import styled from '@emotion/styled'

export const InputsContainer = styled.div`
  display: grid;
  grid-template-columns: 80px 100px 100px 100px;
  column-gap: 15px;
`
